import * as Yup from "yup";
import { ASSET_NETWORK } from "../typings/assets";

export const createTokenEventSchema = Yup.object().shape({
  network: Yup.string().oneOf(Object.values(ASSET_NETWORK)).required(),
  name: Yup.string().required(),
  when: Yup.date().required(),
  token: Yup.string().required(),
});
